import { DrawOpts, NodeModel } from '../../../../types';
import { shapeNames, groupIds } from '../../../../shapes/constants';
import { getOffsetsSum, adjustAttrsPosition } from '../../../../shapes/utils';
import { getNodeIdText } from './helpers';
import { drawDescBottom, drawTitle } from './text';

export const drawWrapper = ({ size, options, group, x, y }: DrawOpts) => {
  const [width, height] = size;

  return group.addShape('rect', {
    name: shapeNames.wrapper,
    className: shapeNames.wrapper,
    draggable: true,
    attrs: adjustAttrsPosition({ width, height, ...options[shapeNames.wrapper] }, { x, y }),
  });
};

export const drawNodeId = ({ options, group, model }: DrawOpts) => {
  return group.addShape('text', {
    className: shapeNames.nodeId,
    draggable: true,
    attrs: {
      text: getNodeIdText(model as NodeModel),
      ...options[shapeNames.nodeId],
    },
  });
};

const getIconBackgroundOffset = (options: DrawOpts['options']) => {
  const iconBackground = options[shapeNames.iconBackground];
  return getOffsetsSum(options.padding, iconBackground.offset, iconBackground.margin);
};

export const drawIcon = ({ options, group, x, y }: DrawOpts) => {
  const { icon, accentColorBackground } = options;
  const iconBackgroundStyle = options[shapeNames.iconBackground];
  const iconGroup = group.addGroup({ id: groupIds.icon });
  const [backgroundOffsetTop, , , backgroundOffsetLeft] = getIconBackgroundOffset(options);

  iconGroup.addShape('rect', {
    name: shapeNames.iconBackground,
    className: shapeNames.iconBackground,
    draggable: true,
    attrs: adjustAttrsPosition(
      {
        fill: accentColorBackground,
        x: backgroundOffsetLeft,
        y: backgroundOffsetTop,
        ...iconBackgroundStyle,
      },
      { x, y },
    ),
  });

  const iconImage = iconGroup.addShape('image', {
    name: shapeNames.icon,
    className: shapeNames.icon,
    draggable: true,
    attrs: adjustAttrsPosition(
      {
        x: iconBackgroundStyle.width / 2 - 2,
        y: iconBackgroundStyle.height / 2 - 3,
        img: icon,
        ...options[shapeNames.icon],
      },
      { x, y },
    ),
  });

  iconImage.toFront();

  return iconGroup;
};

/** Draws a full node */
export const drawNode = (opts: DrawOpts) => {
  const wrapper = drawWrapper(opts);
  drawIcon(opts);
  const title = drawTitle(opts);
  drawDescBottom({ ...opts, yRelativeTo: title });
  return wrapper;
};
